import React, { useState, useEffect, lazy, Suspense } from "react";
import PeriodSlider from "../../components/GlobalComponents/PeriodSlider/PeriodSlider";
import { useSelector } from "react-redux";
import { useGetPriodById } from "../../components/Login/Hooks/Index";
import CircularProgress from "@mui/material/CircularProgress";
import {
  Box,
  Grid,
  Tab,
  Tabs,
  Typography,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  // Button,
} from "@mui/material";
import { AllAlignmentMeeting } from "./LComponents/AllAlignmentMeeting/AllAlignmentMeeting";
import { AllAlignmentRequest } from "./LComponents/AllAlignmentMeeting/AllAlignmentRequest";
// import AllIndexManaging from "./LComponents/AllIndexManaging/AllIndexManaging";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const Index: React.FC = function () {
  const [value, setValue] = React.useState(0);
  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
   const setPeriodIdData = (id: string) => {
     setPeriodId(id);
   };
 
   const onSuccesss = (data: any) => {
     let length = data?.map((e: any) => e.isCurrent).indexOf(true);
     setPeriodId(data[length].id);
     setActiveIndex(length);
   };
 
   const onFailed = (): void => {};
 
   const tenantId: string = useSelector(
     (state: any) => state.meetings.profileTenantId
   );
   const {
     data: perData,
     isLoading: perLoading,
     isError: periodError,
     isFetched,
   }: any = useGetPriodById(tenantId, onSuccesss, onFailed);
   const [activeIndex, setActiveIndex] = useState<number>(0);
   const [periodId, setPeriodId] = useState<string | null>(null);
  // const [teamId, setTeamId] = useState<string>("");
  // const [teamId1, setTeamId1] = useState<string>("");

  // useEffect(() => {
  //   const active: any = perData ? perData[activeIndex] : {};
  //   setPeriodId(active.id);
  // }, [activeIndex]);

  // useEffect(() => {
  //   let length = perData?.map((e: any) => e.isCurrent).indexOf(true);
  //   if (length !== 4) {
  //     setActiveIndex(4);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (perData) {
  //     //NADERI let length: number = perData.length;
  //     // if (length === 4) {
  //     //   setActiveIndex(0);
  //     // }
  //     const currentPeriod = perData?.map((e: any) => e.isCurrent).indexOf(true); //NADERI
  //     setActiveIndex(currentPeriod);
  //   }
  // }, [perData]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
       <PeriodSlider
        setActiveIndex={setActiveIndex}
        setPriodId={setPeriodId}
        activeIndex={activeIndex}
        tenantId={tenantId}
        slideData={perData}
        dataLoading={perLoading}
      />
      <Grid container   >
      <Grid item xs={12} md={12}  >
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="درخواست / پیشنهاد ها" {...a11yProps(0)} style={{color:'black', fontWeight:'700'}}/>
              <Tab label="همه جلسات" {...a11yProps(1)} style={{color:'black', fontWeight:'700'}}/>
            </Tabs>
          </Box>
          
          <CustomTabPanel value={value} index={1}>
            <Suspense fallback={<Box width={'100%'} pt={5} textAlign={'center'} py={5}  ><CircularProgress/></Box>}  >
          <AllAlignmentMeeting
          periodId={periodId}
          periodsData={perData}
          />
            </Suspense>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={0}>
            <Suspense fallback={<Box width={'100%'} pt={5} textAlign={'center'} py={5}  ><CircularProgress/></Box>}  >
          <AllAlignmentRequest
          periodId={periodId}
          periodsData={perData}
          />
            </Suspense>
          </CustomTabPanel>
        </Box>
      </Grid>
      </Grid>
    </>
  );
};

export default Index;
